import { compareStrings } from '../../../../../../../../common/policyPanel/uiSettings/gridTemplate/utils/sorters';
import { ColumnKeys } from '../grid-config';
import { AntimalwareSettingsExclusionsItem } from '@nirvana/shared/dtos/types/policies/common';
import {
  getAntimalwareSettingsExclusionsModuleLabelByType,
  getFullAntimalwareSettingsExclusionsTaskTypeLabelByType,
} from '../../../../../../utils/uiSettings/antimalware/antimalware.values';

// sort by column type
export function sortByColumn(
  item1: AntimalwareSettingsExclusionsItem,
  item2: AntimalwareSettingsExclusionsItem,
  columnName: string,
  direction: string
): number {
  switch (columnName) {
    case ColumnKeys.TYPE:
      return compareStrings(
        getFullAntimalwareSettingsExclusionsTaskTypeLabelByType(item1.taskType),
        getFullAntimalwareSettingsExclusionsTaskTypeLabelByType(item2.taskType),
        direction
      );

    case ColumnKeys.PATH:
      return compareStrings(item1.path, item2.path, direction);

    case ColumnKeys.MODULE:
      return compareStrings(
        item1.module.map(module => getAntimalwareSettingsExclusionsModuleLabelByType(module)).join(','),
        item2.module.map(module => getAntimalwareSettingsExclusionsModuleLabelByType(module)).join(','),
        direction
      );

    case ColumnKeys.REMARKS:
      return compareStrings(item1.remarks, item2.remarks, direction);
  }

  return 0;
}
